import { components } from "react-select";
import { ReactComponent as DownIcon } from "../assets/icons/down_arrow.svg";

const CustomDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownIcon  />
    </components.DropdownIndicator>
  );
};
export default CustomDropdownIndicator;